import styled from 'styled-components';
import logo from './../../_static/logo.png';

export const BackgroundSaveOn = styled.div`
    position: relative;
    width: 98%;
    max-width: 90%;
    margin: 30vh auto 60px;
    padding: 80px 20px 60px;
    border-radius: 50px;
    background-color: #fff;
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
    
    .logo {
        position: relative;
        background: url(${logo}) center center no-repeat;        
        background-size: contain;
        height: 120px;
        min-width: 50px;
        width: 100%;        
    }
  
    .title-page>h2 {
      font-size: 60px;
      font-weight: normal;
    }
    
    .title {
        height: 70px;
        border-right: 3px solid #f0f;
    }
    
    h2 {
        font-size: 40px;
        font-weight: normal;
    }
`;